import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'
import Icon from 'Pods/Shared/Icon/Icon'

class AddToCartButton extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      itemInCart: props.itemInCart,
      disableCheckoutButton: false,
    }

    this.handleProceedToCheckoutClick = this.handleProceedToCheckoutClick.bind(this)
  }

  handleProceedToCheckoutClick = (e) => {
    e.preventDefault()

    if (this.state.disableCheckoutButton) {
      return
    }

    const previousDestination = e.target.href
    this.setState({ disableCheckoutButton: true })
    axios.put('/checkout/track-product-page-proceed-to-checkout-click')
      .then(() => { window.location.href = previousDestination })
  }

  componentDidUpdate(prevProps) {
    if (prevProps.itemInCart !== this.props.itemInCart) this.setState({ itemInCart: this.props.itemInCart })
  }

  render() {
    return (
      <Fragment>
        {this.state.itemInCart ? (
          <a
            className={`btn btn-secondary btn-block animated-button ${this.state.disableCheckoutButton ? 'is-disabled' : ''}`}
            data-id={this.props.id}
            data-meta-source={this.props.metaSource}
            href="/cg/checkout/payment"
            onClick={this.handleProceedToCheckoutClick}
          >
            <Icon type={['fas', 'arrow-right']} /> Proceed to Checkout
          </a>
        ) : (
          <button
            className="btn btn-secondary btn-block js-order"
            data-id={this.props.id}
            data-meta-source={this.props.metaSource}
          >
            <Icon type={['far', 'shopping-cart']} />
            Add to cart <span className="price">{this.props.price}</span>
          </button>
        )}
      </Fragment>
    )
  }
}

AddToCartButton.propTypes = {
  id: PropTypes.string.isRequired,
  price: PropTypes.string.isRequired,
  metaSource: PropTypes.string.isRequired,
  itemInCart: PropTypes.bool,
}

export default AddToCartButton
